// src/components/admin/AdminLogin.js
import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate("/admin/add-product");
    } catch {
      setError("Failed to log in");
      console.error(error);
    }
  };

  return (
    <Container>
      <h1>Admin Login</h1>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <button type="submit">Login</button>
      </form>
    </Container>
  );
};
const Container = styled.div`
  padding: 4em;
  text-align: center;
  margin-top: 5%;
  .error {
    color: red;
    padding: 1em;
  }
  h1 {
    font-family: "Comfortaa";
    font-size: 2.8em;
    margin-bottom: 10px;
  }
  form {
    margin: auto;
    background-color: #303030;
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 40px 30px;
    width: 400px;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    input {
      width: 100%;
      background: none;
      color: white;
      font-size: 18px;
      font-family: "Comfortaa";
      border: 1px solid white;
      border-radius: 20px;
      padding: 14px 14px;
      outline: none;
    }
    button {
      background: white;
      font-family: "Comfortaa", sans-serif;
      padding: 12px 20px;
      border: none;
      border-radius: 30px;
      font-size: 19px;
      margin-top: 1em;
      cursor: pointer;
      transition: 0.4s;
      &:hover {
        background: var(--primaryColor);
        color: white;
      }
    }
  }
  @media (max-width: 550px) {
    padding: 7em 5%;
    h1 {
      font-size: 8vw;
    }
    form {
      width: 100%;
    }
  }
`;

export default AdminLogin;
